import { createContext, useCallback, useContext, useState, type ReactNode } from "react";

interface ProfileNav {
  /** 相手のプロフィールを開きたいという意思表示。Shell がタブを切り替え、Profile が消化する */
  wantsPartner: boolean;
  /** プロフィールタブへ切り替え、相手側の表示を開く */
  goToPartnerProfile: () => void;
  /** Profile 側が読み終わったら呼ぶ */
  consumeTarget: () => void;
}

const ProfileNavContext = createContext<ProfileNav | null>(null);

/**
 * 通知(→ NotificationSheet)からプロフィールタブの相手側へ飛ぶための橋渡し。
 * scheduleNav.tsx と同じ理由(タブ切り替えを Shell の state で持つ SPA なので、
 * 通知はどの画面からでも押されうる一方、遷移先を決められるのは Shell と
 * Profile だけ)。
 */
export function useProfileNav(): ProfileNav {
  const nav = useContext(ProfileNavContext);
  if (nav === null) throw new Error("ProfileNavProvider の外では使えません");
  return nav;
}

export function ProfileNavProvider({ children }: { children: ReactNode }) {
  const [wantsPartner, setWantsPartner] = useState(false);

  const goToPartnerProfile = useCallback(() => {
    setWantsPartner(true);
  }, []);
  const consumeTarget = useCallback(() => {
    setWantsPartner(false);
  }, []);

  return (
    <ProfileNavContext.Provider value={{ wantsPartner, goToPartnerProfile, consumeTarget }}>
      {children}
    </ProfileNavContext.Provider>
  );
}
